import { camelizeDeep } from '@vpr/restful';

import { TagResponse } from './index';
import { TaggingError } from './TaggingError';

/**
 * API to trigger video tagging
 *
 * @param clipId string
 * @param apiUrl string
 * @param jwt string
 * @param flow string
 * @param videoFileId string
 * @param filename string
 * @returns Promise<object>
 */
export const triggerVideoTaggingJob = async (
  clipId: number,
  apiUrl: string,
  jwt: string,
  videoFileId: string,
  flow?: string,
): Promise<TagResponse> => {
  const response = await fetch(`//${apiUrl}/videos/${clipId}/tag_job`, {
    method: 'POST',
    headers: {
      Authorization: `jwt ${jwt}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      flow,
      video_file_id: videoFileId,
    }),
  });
  if (response.ok) {
    const resp = await response.json();
    return camelizeDeep(resp);
  } else {
    let errorResponse: Record<string, unknown> = (await response.json()).catch(() => ({
      empty: true,
    }));
    errorResponse.status = response.status;

    throw new TaggingError(errorResponse, 'Bad response.');
  }
};

/**
 * API to get video tagging job status
 *
 * @param clipID string
 * @param apiUrl string
 * @param jwt string
 * @param id
 * @param filename
 * @returns Promise<object>
 */
export const fetchVideoTaggingJobStatus = async (
  clipId: number,
  apiUrl: string,
  jwt: string,
  id: string,
  filename: string,
): Promise<TagResponse> => {
  const response = await fetch(`//${apiUrl}/videos/${clipId}/tag_job/${id}?filename=${filename}`, {
    method: 'GET',
    headers: {
      Authorization: `jwt ${jwt}`,
    },
  });
  if (response.ok) {
    const resp = await response.json();
    return camelizeDeep(resp);
  } else {
    let errorResponse: Record<string, unknown> = (await response.json()).catch(() => ({
      empty: true,
    }));
    errorResponse.status = response.status;

    throw new TaggingError(errorResponse, 'Bad response.');
  }
};
